import { React, useState, useEffect } from "react";
import { useSelector } from "react-redux";
import Header from "../../../components/admin-header";
import Loader from "../../../components/Loader";
import InputField from "../../../components/inputField";
import Select from "../../../components/select";
import MultiSelect from "../../../components/multi-select";
import MultiColorPicker from "../../../components/multi-color-picker";
import { createClient } from "../../../utils/supbase/client";
import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import { addProductValidationSchema } from "../../../utils/resolvers";
import { useGetAllCategoriesQuery } from "../../../redux/services/categories";
import { useGetAllProductTypeQuery } from "../../../redux/services/product_type";
import {
  useAddProductMutation,
  useUpdateProductMutation,
} from "../../../redux/services/products";
import {
  useAddProductPropertyMutation,
  useGetAllProductPropertiesQuery,
} from "../../../redux/services/product_properties";
import { useLocation, useNavigate } from "react-router-dom";
import LeftSideBar from "../../../components/admin-left-side-bar";
import Breadcrumb from "../../../components/admin-breadcrumb";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

const AddProduct = () => {
  const supabase = createClient();
  const [activeTab, setActiveTab] = useState("General");
  const [isloading, setIsLoading] = useState(false);
  const [properties, setProperties] = useState([{ name: "", value: "" }]);
  const [activeDetailTab, setActiveDetailTab] = useState("Featured Image");
  const [featuredImage, setFeaturedImage] = useState([]);
  const [galleryImages, setGalleryImages] = useState([]);
  const [imageUploading, setImageUploading] = useState(false);

  // const [video, setVideo] = useState(null);
  const { data: categories, isLoading: gettingCategories } =
    useGetAllCategoriesQuery();
  const { data: product_type, isLoading: gettingProductType } =
    useGetAllProductTypeQuery();
  const [addProducts] = useAddProductMutation();

  const [updateProduct, { data: updatedProduct, isLoading: updating }] =
    useUpdateProductMutation();
  const [selectedSizes, setSelectedSizes] = useState([]);
  const [selectedColors, setSelectedColors] = useState([]);
  const user = useSelector((state) => state.auth.user);
  const { state } = useLocation();
  const navigate = useNavigate();
  const [addProductProperty] = useAddProductPropertyMutation();
  const {
    data: allProperties,
    isLoading,
    error,
  } = useGetAllProductPropertiesQuery();

  const sizes = [
    { value: 1, label: "S" },
    { value: 2, label: "M" },
    { value: 3, label: "L" },
    { value: 4, label: "XL" },
  ];
  const colors = [
    { value: 1, label: "Green" },
    { value: 2, label: "Yellow" },
    { value: 3, label: "Red" },
    { value: 4, label: "Blue" },
  ];
  const {
    handleSubmit,
    register,
    setValue,
    watch,
    setError,
    formState: { errors },
    reset,
  } = useForm({
    resolver: addProductValidationSchema,
    defaultValues: {
      productName: state?.product ? state?.product?.title : "",
      productDescription: state?.product ? state?.product?.description : "",
      price: state?.product ? state?.product?.price : 0,
      productCategory: state?.product ? state?.product?.category_id : "",
      productType: state?.product ? state?.product?.product_type_id : "",
      salePrice: state?.product ? state?.product?.sale_price : 0,
      stockQuantity: state?.product ? state?.product?.stock_quantity : 0,
      skuNumber: state?.product ? state?.product?.sku_number : "",
      selectedSizes: state?.product ? state?.product?.size : [],
      selectedColors: state?.product ? state?.product?.color : [],
      featuredImage: state?.product?.image_urls || [],
    },
  });

  const watchedSizes = watch("selectedSizes");
  useEffect(() => {
    if (state?.product?.category_id) {
      setValue("productCategory", state?.product?.category_id);
    }
    if (state?.product?.product_type_id) {
      setValue("productType", state?.product?.product_type_id);
    }
    if (state?.product?.color) {
      setValue("selectedColors", state?.product?.color || []);
    }
  }, [state?.product, setValue]);

  useEffect(() => {
    if (state?.product?.image_urls) {
      const [firstImage, ...restImages] = state?.product?.image_urls || [];
      setFeaturedImage([firstImage]); // Set the first image as featured image
      setGalleryImages(restImages); // Set the remaining images as gallery images
      setValue("featuredImage", [firstImage, ...restImages]); // Update form value
    }
  }, [state?.product, setValue]);
  // const getCategoryTitle = (categoryId) => {
  //   const category = categories?.find((cat) => cat.id === categoryId);
  //   return category ? category.title : "Unknown Category";
  // };

  useEffect(() => {
    if (state?.product?.id && allProperties) {
      const productProperties = allProperties.filter(
        (prop) => prop.product_id === state.product.id
      );

      if (productProperties.length > 0) {
        // Mapping the properties from the API response
        const newProperties = productProperties.map((property) => ({
          id: property.id,
          name: property.name,
          value: property.value,
          product_id: property.product_id,
        }));
        newProperties?.map((property, index) => {
          setValue(`property_name_${index}`, property.name);
          setValue(`property_value_${index}`, property.value);
        });
        setProperties(newProperties);
      }
    }
  }, [state?.product, allProperties]);

  useEffect(() => {
    if (watchedSizes) {
      setSelectedSizes(watchedSizes); // Sync form value with state
    }
  }, [watchedSizes]); // Effect runs when watchedSizes changes

  const handleAddProperty = () => {
    setProperties([...properties, { name: "", value: "" }]);
  };

  const handlePropertyChange = (index, field, value) => {
    const newProperties = [...properties];
    newProperties[index][field] = value;
    setProperties(newProperties);
  };

  const handlePropertyDelete = (index) => {
    const newProperties = properties.filter((_, i) => i !== index);
    setProperties(newProperties);
  };

  // const handleImageChange = (e) => {
  //   const file = e.target.files[0];
  //   console.log("file", file)
  //   if (file) {
  //     setFeaturedImage(URL.createObjectURL(file));
  //   }
  // };

  // const handleGalleryChange = (e) => {
  //   const files = Array.from(e.target.files);
  //   if (files.length) {
  //     const newImages = files.map((file) => URL.createObjectURL(file));
  //     setGalleryImages([...galleryImages, ...newImages]);
  //   }
  // };

  const handleImageChange = async (e) => {
    setImageUploading(true);
    const file = e.target.files[0];

    if (file) {
      const fileName = `${Date.now()}-${file.name}`;
      const { data, error } = await supabase.storage
        .from("tas-e-store/products")
        .upload(fileName, file);

      if (error) {
        console.error("Upload failed:", error.message);
        setImageUploading(false);
      } else {
        const { data: publicUrlData, error: publicUrlError } = supabase.storage
          .from("tas-e-store/products")
          .getPublicUrl(fileName);

        if (publicUrlError) {
          console.error("Error getting public URL:", publicUrlError.message);
          setImageUploading(false);
        } else {
          const publicURL = publicUrlData.publicUrl;
          setFeaturedImage([publicURL]); // Replace the featured image

          setValue("featuredImage", [publicURL, ...galleryImages], {
            shouldValidate: true,
          }); // Ensure form value is updated with both featured and gallery images
          setImageUploading(false);
        }
      }
    }
  };

  const handleGalleryChange = async (e) => {
    setImageUploading(true);

    const files = Array.from(e.target.files);

    if (files.length) {
      const uploadedGalleryUrls = await Promise.all(
        files.map(async (file) => {
          const fileName = `${Date.now()}-${file.name}`;
          const { data, error } = await supabase.storage
            .from("tas-e-store/products")
            .upload(fileName, file);

          if (error) {
            console.error("Upload failed:", error.message);
        setImageUploading(false);

            return null;
          }

          const { data: publicUrlData, error: publicUrlError } =
            supabase.storage
              .from("tas-e-store/products")
              .getPublicUrl(fileName);

          if (publicUrlError) {
            console.error("Error getting public URL:", publicUrlError.message);
        setImageUploading(false);

            return null;
          }

          return publicUrlData.publicUrl; // Return the public URL
        })
      );

      // Filter out any null URLs (in case some uploads failed)
      const validGalleryUrls = uploadedGalleryUrls.filter(
        (url) => url !== null
      );

      // Append the new gallery images to the existing gallery images
      const updatedGalleryImages = [...galleryImages, ...validGalleryUrls];

      // Update galleryImages state
      setGalleryImages(updatedGalleryImages);

      // Update featuredImage array while keeping the first index for the main featured image
      setFeaturedImage([featuredImage[0], ...updatedGalleryImages]);

      // Update the form value with the new array
      setValue("featuredImage", [featuredImage[0], ...updatedGalleryImages], {
        shouldValidate: true,
      });
      setImageUploading(false);
    }
  };

  // const handleVideoChange = (e) => {
  //   const file = e.target.files[0];
  //   if (file) {
  //     setVideo(URL.createObjectURL(file));
  //   }
  // };

  const handleSizeChange = (selectedValues) => {
    setSelectedSizes(selectedValues);
    setValue("selectedSizes", selectedValues, { shouldValidate: true });
  };
  // const handleColorChange = (selectedValues) => {
  //   setSelectedColors(selectedValues);
  // };

  const tabs = [
    "General",
    "Properties",
    "Inventory",
    "Attributes",
    // "Shipping",
    // "Tags",
  ];
  const detailTabs = [
    "Featured Image",
    "Product Gallery",
    //  "Video"
  ];

  const handlePublish = async (formValues) => {
    console.log("Values", formValues, properties);

    if (Object.keys(errors).length > 0) {
      console.log("Validation errors:", errors);
      toast.warning("Please resolve errors to proceed.");
      return;
    }

    try {
      setIsLoading(true);
      const {
        productName,
        productDescription,
        price,
        productCategory,
        productType,
        salePrice,
        stockQuantity,
        skuNumber,
      } = formValues;

      let productId;

      if (state?.product) {
        await updateProduct({
          id: state?.product?.id,
          title: productName,
          description: productDescription,
          price: price,
          category_id: productCategory,
          user_id: user?.id,
          image_urls:
            featuredImage.length > 0 ? featuredImage : watch("featuredImage"),
          product_type_id: productType,
          sale_price: salePrice,
          size: selectedSizes,
          color:
            selectedColors.length > 0
              ? selectedColors
              : watch("selectedColors"),
          stock_quantity: stockQuantity,
          sku_number: skuNumber,
        });
        productId = state?.product?.id;
        // {
        //   properties[0]?.name !== "" &&
        //     productId &&
        //     properties.map(async (property) => {
        //       await addProductProperty({
        //         name: property.name,
        //         value: property.value,
        //         product_id: productId,
        //       });
        //     });
        // }
      } else {
        const addedProduct = await addProducts({
          title: productName,
          description: productDescription,
          price: price,
          category_id: productCategory,
          user_id: user?.id,
          image_urls: featuredImage,
          product_type_id: productType,
          sale_price: salePrice,
          size: selectedSizes,
          color: selectedColors,
          stock_quantity: stockQuantity,
          sku_number: skuNumber,
        });
        productId = addedProduct?.data[0]?.id;
        {
          properties[0]?.name !== "" &&
            productId &&
            properties.map(async (property) => {
              await addProductProperty({
                name: property.name,
                value: property.value,
                product_id: productId,
              });
            });
        }
      }
    } catch (err) {
      console.log(err);
    } finally {
      setIsLoading(false);
      navigate("/admin/product-listing");
    }
  };
  const [isSidebarVisible, setSidebarVisible] = useState(false);
  const [isSidebarCollapsed, setSidebarCollapsed] = useState(false);

  const toggleSidebar = () => {
    setSidebarVisible(!isSidebarVisible);
  };

  const toggleCollapse = () => {
    setSidebarCollapsed(!isSidebarCollapsed);
  };

  return (
    <>
      <div className="flex min-h-screen bg-background w-full gap-6 font-poppins">
        <LeftSideBar
          isVisible={isSidebarVisible}
          toggleSidebar={toggleSidebar}
          isCollapsed={isSidebarCollapsed}
          toggleCollapse={toggleCollapse}
        />

        <div className="flex flex-1 flex-col overflow-auto h-screen w-full">
          <Header toggleSidebar={toggleSidebar} />
          <div className="md:pr-6 pr-2 pl-2 md:pl-0 ">
            {/* <section className="w-full py-2 ">
              <Breadcrumb />
            </section> */}
            <div className="container mx-auto px-0 py-3">
              <div className="flex justify-between items-center mb-6">
                <h1 className="text-3xl font-bold">
                  {state?.product ? "Update Product" : "Add New Product"}
                </h1>
                <button
                  type="submit"
                  onClick={handleSubmit(handlePublish)}
                  className="bg-orange-500 text-white py-2 px-4 rounded w-28 h-10"
                >
                  {isloading ? (
                    <Loader height="h-5" width="w-5" color="#ffffff" />
                  ) : state?.product ? (
                    "Update"
                  ) : (
                    "Publish"
                  )}
                </button>
                {/* <ToastContainer /> */}
              </div>

              <hr className="border-[#EAECF0] border-b my-6" />

              <form className="bg-white py-6">
                <div className="mb-4">
                  <label className="block text-gray-700 font-bold mb-2">
                    Product Name
                  </label>
                  <InputField
                    register={register}
                    placeholder="Enter product name"
                    name={"productName"}
                    // onChange={(value) => {
                    //   setValue("productName", value);
                    //   setError("productName", null);
                    // }}
                    errorMsg={
                      errors?.productName && errors?.productName?.message
                    }
                  />
                </div>

                <div className="mb-4">
                  <Select
                    label={"Product Category"}
                    name={"productCategory"}
                    placeholder={"Select a Product Category"}
                    options={(categories || [])?.map((cat) => {
                      return {
                        label: cat.title,
                        value: cat.id,
                      };
                    })}
                    value={watch("productCategory")}
                    setValue={setValue}
                    // onChange={(value) => {
                    //   setValue("productCategory", value);
                    //   setError("productCategory", null);
                    // }}
                    errorMsg={errors.productCategory?.message}
                  />
                </div>

                <div className="mb-4">
                  <Select
                    label={"Product Type"}
                    name={"productType"}
                    placeholder={"Select a Product Type"}
                    options={(product_type || [])?.map((product) => {
                      return {
                        label: product.name,
                        value: product.id,
                      };
                    })}
                    value={watch("productType")}
                    setValue={setValue}
                    // onChange={(value) => {
                    //   setValue("productType", value);
                    //   setError("productType", null);
                    // }}
                    errorMsg={errors.productType?.message}
                  />
                </div>

                <div className="mb-4">
                  <label className="block text-gray-700 font-bold mb-2">
                    Short description
                  </label>
                  <textarea
                    {...register("productDescription")}
                    className="mt-3 w-full py-2 px-3 bg-transparent dark:bg-slate-900 dark:text-slate-200 rounded outline-none border border-gray-100 dark:border-gray-800 focus:ring-0"
                    rows="6"
                    placeholder="Enter description"
                    name={"productDescription"}
                    setValue={setValue}
                    // onChange={(event) => {
                    //   setValue("productDescription", event.target.value);
                    //   setError("productDescription", null);
                    // }}
                  ></textarea>
                  {errors?.productDescription?.message && (
                    <div className="text-red-500 my-2">
                      {errors?.productDescription?.message}
                    </div>
                  )}
                </div>

                {/* <div className="flex mb-4">
              <div className="w-1/2 pr-2">
                <Select label={"Sub-category"} />
              </div>
              <div className="w-1/2 pl-2">
                <Select label={"Child-category"} />
              </div>
            </div> */}
              </form>

              <div className="mt-8">
                <div className="">
                  <span className="block text-gray-700 font-bold">
                    Product Details
                  </span>
                  <span className="block text-[#667085] mb-2">
                    Please include product details for better user
                    understanding.
                  </span>
                </div>
                <div className="flex border-b mb-4">
                  {tabs.map((tab) => (
                    <button
                      key={tab}
                      className={`py-2 px-4 ${
                        activeTab === tab
                          ? "border-b-2 border-orange-500 text-orange-500 font-bold"
                          : "text-gray-500"
                      }`}
                      onClick={() => setActiveTab(tab)}
                    >
                      {tab}
                    </button>
                  ))}
                </div>

                <div className="mt-4">
                  {activeTab === "General" && (
                    <div>
                      <h3 className="text-xl font-bold mb-4">General</h3>
                      <div className="flex mb-4">
                        <div className="w-1/2 pr-2">
                          <label className="block text-gray-700 font-bold mb-2">
                            Regular Price
                          </label>
                          <InputField
                            register={register}
                            placeholder="Enter regular price"
                            name={"price"}
                            // onChange={(value) => {
                            //   setValue("price", value);
                            //   setError("price", null);
                            // }}
                            errorMsg={errors.price?.message}
                          />
                        </div>
                        <div className="w-1/2 pl-2">
                          <label className="block text-gray-700 font-bold mb-2">
                            Sale Price
                          </label>
                          <InputField
                            register={register}
                            placeholder="Enter sale price"
                            name={"salePrice"}
                            // onChange={(value) => {
                            //   setValue("salePrice", value);
                            //   setError("salePrice", null);
                            // }}
                            errorMsg={errors.salePrice?.message}
                          />
                        </div>
                      </div>
                    </div>
                  )}

                  {activeTab === "Properties" && (
                    <div>
                      <h3 className="text-xl font-bold mb-4">Properties</h3>
                      {properties.map((property, index) => (
                        <div key={index} className="flex mb-4">
                          <div className="w-1/2 pr-2">
                            <label className="block text-gray-700 font-bold mb-2">
                              Name
                            </label>
                            <InputField
                              register={register}
                              placeholder="Enter property name"
                              name={`property_name_${index}`}
                              value={property.name}
                              onChange={(value) =>
                                handlePropertyChange(index, "name", value)
                              }
                            />
                          </div>
                          <div className="w-1/2 pl-2">
                            <label className="block text-gray-700 font-bold mb-2">
                              Value
                            </label>
                            <InputField
                              register={register}
                              placeholder="Enter property value"
                              name={`property_value_${index}`}
                              value={property.value}
                              onChange={(value) =>
                                handlePropertyChange(index, "value", value)
                              }
                            />
                          </div>
                          <button
                            type="button"
                            className="ml-4 text-red-500 hover:text-red-700 mt-11"
                            onClick={() => handlePropertyDelete(index)}
                          >
                            Delete
                          </button>
                        </div>
                      ))}
                      <button
                        type="button"
                        className="bg-white-500 text-orange py-2 px-4 rounded"
                        onClick={handleAddProperty}
                      >
                        Add More
                      </button>
                    </div>
                  )}

                  {activeTab === "Inventory" && (
                    <div>
                      <h3 className="text-xl font-bold mb-4">Inventory</h3>
                      <div className="mb-4">
                        <div className="mb-4">
                          <label className="block text-gray-700 font-bold mb-2">
                            SKU Number
                          </label>
                          <InputField
                            register={register}
                            placeholder="Enter SKU number"
                            name={"skuNumber"}
                            // onChange={(value) => {
                            //   setValue("skuNumber", value);
                            //   setError("skuNumber", null);
                            // }}
                            errorMsg={errors.skuNumber?.message}
                          />
                        </div>
                        <div className="flex">
                          <div className="w-1/2 pr-4">
                            <label className="block text-gray-700 font-bold mb-2">
                              Stock Quantity
                            </label>
                            <InputField
                              register={register}
                              placeholder="Enter stock quantity"
                              name={"stockQuantity"}
                              // onChange={(value) => {
                              //   setValue("stockQuantity", value);
                              //   setError("stockQuantity", null);
                              // }}
                              errorMsg={errors.stockQuantity?.message}
                            />
                          </div>
                          {/* <div className="w-1/2">
                        <label className="block text-gray-700 font-bold mb-2">
                          Low Stock Threshold
                        </label>
                        <InputField placeholder="Enter low stock threshold" />
                      </div> */}
                        </div>
                      </div>
                    </div>
                  )}

                  {activeTab === "Attributes" && (
                    <div>
                      <h3 className="text-xl font-bold mb-4">Attributes</h3>
                      <div className="flex mb-4">
                        <div className="w-1/2 pr-2">
                          <MultiSelect
                            label={"Size"}
                            options={sizes}
                            selectedValues={selectedSizes}
                            onChange={handleSizeChange}
                            errorMsg={errors.selectedSizes?.message}
                          />
                        </div>
                        <div className="w-1/2 pl-2">
                          {/* <MultiSelect
                        label={"Colors"}
                        options={colors}
                        selectedValues={selectedColors}
                        onChange={handleColorChange}
                      /> */}
                          <MultiColorPicker
                            label={"Colors"}
                            selectedColors={watch("selectedColors")}
                            onChange={setSelectedColors}
                            setValue={setValue}
                            errorMsg={errors.selectedColors?.message}
                          />
                        </div>
                      </div>
                    </div>
                  )}

                  {/* {activeTab === "Shipping" && (
                <div>
                  <h3 className="text-xl font-bold mb-4">Shipping</h3>
                  <div className="mb-4">
                    <label className="block text-gray-700 font-bold mb-2">
                      Package Weight
                    </label>
                    <InputField placeholder="Enter package weight" />
                  </div>
                  <div className="flex mb-4">
                    <div className="w-1/3 pr-2">
                      <label className="block text-gray-700 font-bold mb-2">
                        Length
                      </label>
                      <InputField placeholder="Enter length" />
                    </div>
                    <div className="w-1/3 px-2">
                      <label className="block text-gray-700 font-bold mb-2">
                        Width
                      </label>
                      <InputField placeholder="Enter width" />
                    </div>
                    <div className="w-1/3 pl-2">
                      <label className="block text-gray-700 font-bold mb-2">
                        Height
                      </label>
                      <InputField placeholder="Enter height" />
                    </div>
                  </div>
                  <div className="flex">
                    <div className="w-1/2 pr-2">
                      <label className="block text-gray-700 font-bold mb-2">
                        Shipping Charges
                      </label>
                      <InputField placeholder="Enter shipping charges" />
                    </div>
                  </div>
                </div>
              )} */}

                  {/* {activeTab === "Tags" && (
                <div>
                  <h3 className="text-xl font-bold mb-4">Tags</h3>
                  <div className="mb-4">
                    <label className="block text-gray-700 font-bold mb-2">
                      Tags
                    </label>
                    <InputField placeholder="Enter tags" />
                  </div>
                </div>
              )} */}
                </div>
              </div>

              <div className="mt-8">
                <h2 className="text-2xl font-bold mb-4">Product Images</h2>
                <div className="flex border-b mb-4">
                  {detailTabs.map((tab) => (
                    <button
                      key={tab}
                      className={`py-2 px-4 ${
                        activeDetailTab === tab
                          ? "border-b-2 border-orange-500 text-orange-500 font-bold"
                          : "text-gray-500"
                      }`}
                      onClick={() => setActiveDetailTab(tab)}
                    >
                      {tab}
                    </button>
                  ))}
                </div>

                <div className="mt-4">
                  {activeDetailTab === "Featured Image" && (
                    <div>
                      <div className="mb-4 text-center">
                        <label className="relative border border-gray-300 rounded-lg bg-white-50 p-8 flex flex-col justify-center items-center cursor-pointer">
                          <input
                            type="file"
                            accept="image/png, image/jpeg"
                            onChange={handleImageChange}
                            className="absolute inset-0 w-full h-full opacity-0 cursor-pointer"
                          />

                          <svg
                            height="80px"
                            width="80px"
                            viewBox="0 0 184.69 184.69"
                            xmlns="http://www.w3.org/2000/svg"
                            xmlnsXlink="http://www.w3.org/1999/xlink"
                            xmlSpace="preserve"
                            className="h-12 w-12 text-gray-400 mb-4"
                          >
                            <g>
                              <g>
                                <g>
                                  <path
                                    style={{ fill: "#010002" }}
                                    d="M149.968,50.186c-8.017-14.308-23.796-22.515-40.717-19.813
        C102.609,16.43,88.713,7.576,73.087,7.576c-22.117,0-40.112,17.994-40.112,40.115c0,0.913,0.036,1.854,0.118,2.834
        C14.004,54.875,0,72.11,0,91.959c0,23.456,19.082,42.535,42.538,42.535h33.623v-7.025H42.538
        c-19.583,0-35.509-15.929-35.509-35.509c0-17.526,13.084-32.621,30.442-35.105c0.931-0.132,1.768-0.633,2.326-1.392
        c0.555-0.755,0.795-1.704,0.644-2.63c-0.297-1.904-0.447-3.582-0.447-5.139c0-18.249,14.852-33.094,33.094-33.094
        c13.703,0,25.789,8.26,30.803,21.04c0.63,1.621,2.351,2.534,4.058,2.14c15.425-3.568,29.919,3.883,36.604,17.168
        c0.508,1.027,1.503,1.736,2.641,1.897c17.368,2.473,30.481,17.569,30.481,35.112c0,19.58-15.937,35.509-35.52,35.509H97.391
        v7.025h44.761c23.459,0,42.538-19.079,42.538-42.535C184.69,71.545,169.884,53.901,149.968,50.186z"
                                  />
                                </g>
                                <g>
                                  <path
                                    style={{ fill: "#010002" }}
                                    d="M108.586,90.201c1.406-1.403,1.406-3.672,0-5.075L88.541,65.078
        c-0.701-0.698-1.614-1.045-2.534-1.045l-0.064,0.011c-0.018,0-0.036-0.011-0.054-0.011c-0.931,0-1.85,0.361-2.534,1.045
        L63.31,85.127c-1.403,1.403-1.403,3.672,0,5.075c1.403,1.406,3.672,1.406,5.075,0L82.296,76.29v97.227
        c0,1.99,1.603,3.597,3.593,3.597c1.979,0,3.59-1.607,3.59-3.597V76.165l14.033,14.036
        C104.91,91.608,107.183,91.608,108.586,90.201z"
                                  />
                                </g>
                              </g>
                            </g>
                          </svg>

                          {imageUploading ? (
                            <Loader height="h-5" width="w-5" color="#F87315" />
                          ) : (
                            <>
                              <span className="block text-gray-600">
                                <span className="text-orange-500 font-bold">
                                  Click to Upload
                                </span>{" "}
                                or drag and drop
                              </span>

                              <span>PNG or JPG</span>
                            </>
                          )}
                        </label>
                        {errors?.featuredImage?.message && (
                          <div className="text-red-500 my-2">
                            {errors?.featuredImage?.message}
                          </div>
                        )}
                        {watch("featuredImage")?.length > 0 && (
                          <img
                            src={
                              featuredImage.length > 0
                                ? featuredImage
                                : watch("featuredImage")[0]
                            }
                            alt="Featured"
                            className="w-full h-auto object-cover rounded-lg mt-4 max-w-xs"
                          />
                        )}
                      </div>
                    </div>
                  )}

                  {activeDetailTab === "Product Gallery" && (
                    <div>
                      <div className="mb-4 text-center">
                        <label className="relative border border-gray-300 rounded-lg bg-white-50 p-8 flex flex-col justify-center items-center cursor-pointer">
                          <input
                            type="file"
                            accept="image/png, image/jpeg"
                            onChange={handleGalleryChange}
                            className="absolute inset-0 w-full h-full opacity-0 cursor-pointer"
                          />
                          <svg
                            height="80px"
                            width="80px"
                            viewBox="0 0 184.69 184.69"
                            xmlns="http://www.w3.org/2000/svg"
                            xmlnsXlink="http://www.w3.org/1999/xlink"
                            xmlSpace="preserve"
                            className="h-12 w-12 text-gray-400 mb-4"
                          >
                            <g>
                              <g>
                                <g>
                                  <path
                                    style={{ fill: "#010002" }}
                                    d="M149.968,50.186c-8.017-14.308-23.796-22.515-40.717-19.813
        C102.609,16.43,88.713,7.576,73.087,7.576c-22.117,0-40.112,17.994-40.112,40.115c0,0.913,0.036,1.854,0.118,2.834
        C14.004,54.875,0,72.11,0,91.959c0,23.456,19.082,42.535,42.538,42.535h33.623v-7.025H42.538
        c-19.583,0-35.509-15.929-35.509-35.509c0-17.526,13.084-32.621,30.442-35.105c0.931-0.132,1.768-0.633,2.326-1.392
        c0.555-0.755,0.795-1.704,0.644-2.63c-0.297-1.904-0.447-3.582-0.447-5.139c0-18.249,14.852-33.094,33.094-33.094
        c13.703,0,25.789,8.26,30.803,21.04c0.63,1.621,2.351,2.534,4.058,2.14c15.425-3.568,29.919,3.883,36.604,17.168
        c0.508,1.027,1.503,1.736,2.641,1.897c17.368,2.473,30.481,17.569,30.481,35.112c0,19.58-15.937,35.509-35.52,35.509H97.391
        v7.025h44.761c23.459,0,42.538-19.079,42.538-42.535C184.69,71.545,169.884,53.901,149.968,50.186z"
                                  />
                                </g>
                                <g>
                                  <path
                                    style={{ fill: "#010002" }}
                                    d="M108.586,90.201c1.406-1.403,1.406-3.672,0-5.075L88.541,65.078
        c-0.701-0.698-1.614-1.045-2.534-1.045l-0.064,0.011c-0.018,0-0.036-0.011-0.054-0.011c-0.931,0-1.85,0.361-2.534,1.045
        L63.31,85.127c-1.403,1.403-1.403,3.672,0,5.075c1.403,1.406,3.672,1.406,5.075,0L82.296,76.29v97.227
        c0,1.99,1.603,3.597,3.593,3.597c1.979,0,3.59-1.607,3.59-3.597V76.165l14.033,14.036
        C104.91,91.608,107.183,91.608,108.586,90.201z"
                                  />
                                </g>
                              </g>
                            </g>
                          </svg>

                          {imageUploading ? (
                            <Loader height="h-5" width="w-5" color="#F87315" />
                          ) : (
                            <>
                              <span className="block text-gray-600">
                                <span className="text-orange-500 font-bold">
                                  Click to Upload
                                </span>{" "}
                                or drag and drop
                              </span>

                              <span>PNG or JPG</span>
                            </>
                          )}
                        </label>
                        <div className="grid grid-cols-3 gap-4">
                          {galleryImages.map((image, index) => (
                            <img
                              key={index}
                              src={image}
                              alt={`Image ${index}`}
                              className="w-full h-auto object-cover rounded-lg mt-4 max-w-xs"
                            />
                          ))}
                        </div>
                      </div>
                    </div>
                  )}

                  {/* {activeDetailTab === "Video" && (
                <div>
                  <div className="mb-4 text-center">
                    <label className="relative border border-gray-300 rounded-lg bg-white-50 p-8 flex flex-col justify-center items-center cursor-pointer">
                      <input
                        type="file"
                        accept="video/mp4"
                        onChange={handleVideoChange}
                        className="absolute inset-0 w-full h-full opacity-0 cursor-pointer"
                      />
                      <svg
                        height="80px"
                        width="80px"
                        viewBox="0 0 184.69 184.69"
                        xmlns="http://www.w3.org/2000/svg"
                        xmlnsXlink="http://www.w3.org/1999/xlink"
                        xmlSpace="preserve"
                        className="h-12 w-12 text-gray-400 mb-4"
                      >
                        <g>
                          <g>
                            <g>
                              <path
                                style={{ fill: "#010002" }}
                                d="M149.968,50.186c-8.017-14.308-23.796-22.515-40.717-19.813
        C102.609,16.43,88.713,7.576,73.087,7.576c-22.117,0-40.112,17.994-40.112,40.115c0,0.913,0.036,1.854,0.118,2.834
        C14.004,54.875,0,72.11,0,91.959c0,23.456,19.082,42.535,42.538,42.535h33.623v-7.025H42.538
        c-19.583,0-35.509-15.929-35.509-35.509c0-17.526,13.084-32.621,30.442-35.105c0.931-0.132,1.768-0.633,2.326-1.392
        c0.555-0.755,0.795-1.704,0.644-2.63c-0.297-1.904-0.447-3.582-0.447-5.139c0-18.249,14.852-33.094,33.094-33.094
        c13.703,0,25.789,8.26,30.803,21.04c0.63,1.621,2.351,2.534,4.058,2.14c15.425-3.568,29.919,3.883,36.604,17.168
        c0.508,1.027,1.503,1.736,2.641,1.897c17.368,2.473,30.481,17.569,30.481,35.112c0,19.58-15.937,35.509-35.52,35.509H97.391
        v7.025h44.761c23.459,0,42.538-19.079,42.538-42.535C184.69,71.545,169.884,53.901,149.968,50.186z"
                              />
                            </g>
                            <g>
                              <path
                                style={{ fill: "#010002" }}
                                d="M108.586,90.201c1.406-1.403,1.406-3.672,0-5.075L88.541,65.078
        c-0.701-0.698-1.614-1.045-2.534-1.045l-0.064,0.011c-0.018,0-0.036-0.011-0.054-0.011c-0.931,0-1.85,0.361-2.534,1.045
        L63.31,85.127c-1.403,1.403-1.403,3.672,0,5.075c1.403,1.406,3.672,1.406,5.075,0L82.296,76.29v97.227
        c0,1.99,1.603,3.597,3.593,3.597c1.979,0,3.59-1.607,3.59-3.597V76.165l14.033,14.036
        C104.91,91.608,107.183,91.608,108.586,90.201z"
                              />
                            </g>
                          </g>
                        </g>
                      </svg>

                      <span className="block text-gray-600">
                        <span className="text-orange-500 font-bold">
                          Click to Upload
                        </span>{" "}
                        or drag and drop
                      </span>

                      <span>MP4</span>
                    </label>
                    {video && (
                      <video
                        src={video}
                        controls
                        className="w-full h-auto object-cover rounded-lg mt-4 max-w-xs"
                      />
                    )}
                  </div>
                </div>
              )} */}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default AddProduct;
